module.exports = __webpack_public_path__ + "static/img/quanmin_ydh2.1a69cea7.png";